import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'

import { getTokenType } from 'utils/tokenTypes'
import Layout from '../../../components/common/Layout'
import CheckBox from '../../../components/common/CheckBox'
import NoContent from '../../../components/common/NoContent'
import Loading from '../../../components/common/Loading'
import FontNumber from '../../../components/common/FontNumber'
import OrderTable from '../../../components/order/OrderTable'
import Filled from '../../../components/order/Filled'
import Side from '../../../components/order/Side'
import Status from '../../../components/order/Status'
import TxHash from '../../../components/order/TxHash'
import OrderHistoryMobileItem from './OrderHistoryMobileItem'

import OrderHistoryFilter from '../../../components/order/OrderHistoryFilter'
import { getOrderHistoryQS } from '../../../redux/order/action'
import httpRequest from '../../../utils/httpRequest'
import { roundValue, toNonExponential } from '../../../utils/number'
import convertOrderStatus from '../../../utils/convertOrderStatus'
import { withI18n } from '../../../i18n/util'
import reduceTradePairBSufix from '../../../utils/tradepair'
import { DexThemeProvider } from '../../../components/common/DexThemeProvider'

const PAGE_SIZE = 25
const TRADE_API = '/api/v1/trades'
const GATE_WAY = httpRequest.getHttpBaseUri()

const Wrapper = styled.div`
  background: #fdfdfd;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  width: 1200px;
  min-width: 960px;
  @media (min-width: 320px) and (max-width: 623px) {
    display: none;
  }
`

export const MobileContent = styled.div`
  width: 100%;
  padding: 20px;
  padding-top: 0;
  display: none;
  min-width: 320px;
  @media (min-width: 320px) and (max-width: 623px) {
    display: block;
  }
  .infinite-scroll-component {
    padding: 5px;
    h4 {
      text-align: center;
      font-size: 16px;
    }
  }
`

const Title = styled.div`
  color: #212833;
  font-size: 20px;
  background: #fff;
  height: 40px;
  line-height: 40px;
`

const FilterWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  box-shadow: 0px 1px 20px 0px rgba(90, 102, 124, 0.08);
  height: 40px;
  padding: 0 5px 0 15px;
`
const CellItem = styled.div`
  color: #212833;
`

const DateItem = styled.div`
  color: #848e9c;
`

const CellItemCancel = styled(CellItem)`
  color: #48515d;
`

const DetailContent = styled.div`
  padding: 5px 30px;
  background: #fff;
  max-height: 300px;
  overflow: auto;
  thead th {
    background-color: #fff;
  }
  tbody tr {
    box-shadow: none;
    &:hover {
      box-shadow: none;
    }
  }
  tbody td {
    background: #f7f7f7;
  }
`

const DetailTotalValue = styled.p`
  color: #212833;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
  margin-top: 10px;
`

class OrderHistory extends PureComponent {
  static propTypes = {
    orderHistory: PropTypes.array,
    total: PropTypes.number,
    address: PropTypes.string,
    dispatch: PropTypes.func,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    orderHistory: [],
    total: 0,
    address: '',
    dispatch: () => {},
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      isHide: false,
      isClickDetail: false,
      filterParams: {},
      offset: 0,
      orders: [],
    }
  }

  componentDidMount() {
    const currentDate = new Date()
    const start = currentDate.setDate(currentDate.getDate() - 7)
    const end = new Date()
    const opts = {
      start: new Date(`${moment(start).format('YYYY/MM/DD')} 00:00:00`).getTime(),
      end: new Date(`${moment(end).format('YYYY/MM/DD')} 23:59:59`).getTime(),
    }

    this._getOrderHistory(opts)
  }

  componentDidUpdate() {
    const { orders } = this.state
    const { orderHistory } = this.props
    if (orders.length === 0 && orderHistory.length > 0) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ orders: orders.concat(orderHistory) })
    }
  }

  _getOrderHistory = opts => {
    const { dispatch } = this.props
    const { filterParams } = this.state
    const tokenType = getTokenType()
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) return
    const params = {
      address: user.address,
      offset: 0,
      total: 1,
      limit: PAGE_SIZE,
      ...filterParams,
      ...opts,
    }
    dispatch(getOrderHistoryQS({ params, withLoading: true, tokenType }))
  }

  _handleCheckChange = e => {
    const checked = e.target.checked //eslint-disable-line
    this.setState({ isHide: checked }, () => {
      const opts = {}
      if (checked) {
        opts.status = [
          'Ack',
          'PartialFill',
          'IocNoFill',
          'FullyFill',
          'Expired',
          'Unknown',
          'FailedBlocking',
          'FailedMatching',
        ]
      } else {
        delete opts.status
      }
      this._getOrderHistory(opts)
    })
  }

  _paging = current => {
    const { isHide } = this.state
    const opts = { offset: (current - 1) * PAGE_SIZE }
    if (isHide) {
      opts.status = [
        'Ack',
        'PartialFill',
        'IocNoFill',
        'FullyFill',
        'Expired',
        'Unknown',
        'FailedBlocking',
        'FailedMatching',
      ]
    }

    this._getOrderHistory(opts)
  }

  _buildColumns = () => {
    const { formatI18nText } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.txHash'),
        headerAlign: 'left',
        sorter: true,
        dataIndex: 'txHash',
        key: 'TxHash',
        width: '20%',
        render: item => (
          <div>
            <TxHash hash={item.txHash} />
          </div>
        ),
      },
      {
        title: formatI18nText('exchange.date'),
        dataIndex: 'date',
        headerAlign: 'left',
        sorter: true,
        key: 'Date',
        width: '10%',
        render: item => (
          <DateItem>
            <FontNumber value={moment(item.date).format('MM-DD H:mm:ss')} />
          </DateItem>
        ),
      },
      {
        title: formatI18nText('exchange.pair'),
        dataIndex: 'pair',
        key: 'Pair',
        width: '10%',
        render: item => {
          if (item.status.toUpperCase() === 'CANCELED') {
            return <CellItemCancel>{item.pair}</CellItemCancel>
          }
          return <CellItem>{item.pair}</CellItem>
        },
      },
      {
        title: formatI18nText('exchange.side'),
        dataIndex: 'side',
        key: 'Side',
        width: '5%',
        render: item => {
          if (item.status.toUpperCase() === 'CANCELED') {
            return <CellItemCancel>{item.side}</CellItemCancel>
          }
          return <Side text={item.side} />
        },
      },
      {
        title: formatI18nText('exchange.price'),
        dataIndex: 'price',
        key: 'Price',
        width: '10%',
        render: item => {
          if (item.status.toUpperCase() === 'CANCELED') {
            return (
              <CellItemCancel>
                <FontNumber value={toNonExponential(item.price)} />
              </CellItemCancel>
            )
          }
          return (
            <CellItem>
              <FontNumber value={toNonExponential(item.price)} />
            </CellItem>
          )
        },
      },
      {
        title: formatI18nText('exchange.amount'),
        dataIndex: 'amount',
        key: 'Amount',
        width: '10%',
        render: item => {
          if (item.status.toUpperCase() === 'CANCELED') {
            return (
              <CellItemCancel>
                <FontNumber value={item.amount} />
              </CellItemCancel>
            )
          }
          return (
            <CellItem>
              <FontNumber value={item.amount} />
            </CellItem>
          )
        },
      },
      {
        title: formatI18nText('exchange.filled'),
        dataIndex: 'filled',
        key: 'Filled',
        width: '10%',
        render: item => {
          return <Filled value={item.filled} status={item.status} />
        },
      },
      {
        title: formatI18nText('exchange.total'),
        dataIndex: 'total',
        key: 'Total',
        width: '10%',
        render: item => {
          if (item.status.toUpperCase() === 'CANCELED') {
            return (
              <CellItemCancel>
                <FontNumber value={item.total && item.total} />
              </CellItemCancel>
            )
          }
          return (
            <CellItem>
              <FontNumber value={item.total && item.total} />
            </CellItem>
          )
        },
      },
      {
        title: formatI18nText('exchange.status'),
        dataIndex: 'status',
        key: 'Status',
        width: '10%',
        render: item => <Status text={item.status} />,
      },
    ]
    return columns
  }

  _buildDataSource = () => {
    const { orderHistory } = this.props
    const result = []
    orderHistory.forEach(order => {
      result.push({
        txHash: order.transactionHash,
        id: order.orderId,
        date: order.orderCreateTime,
        pair: reduceTradePairBSufix(order.symbol),
        side: order.side === 1 ? 'Buy' : 'Sell',
        average: order.average,
        price: parseFloat(roundValue(order.price)),
        amount: parseFloat(roundValue(order.quantity)),
        cumulateQuantity: parseFloat(roundValue(order.cumulateQuantity)),
        filled: (order.cumulateQuantity / order.quantity) * 100,
        total: parseFloat(roundValue(order.price * order.quantity)),
        status: convertOrderStatus(order.status),
      })
    })

    return result
  }

  _filter = params => {
    const opts = {}
    const { isHide } = this.state

    if (params.baseAsset && params.quoteAsset) {
      opts.symbol = `${params.baseAsset}_${params.quoteAsset}`
    }

    if (params.manualStartDate) {
      opts.start = params.manualStartDate.getTime()
    }

    if (params.manualEndDate) {
      opts.start = new Date(
        `${moment(params.manualStartDate).format('YYYY/MM/DD')} 00:00:00`
      ).getTime()
      opts.end = new Date(`${moment(params.manualEndDate).format('YYYY/MM/DD')} 23:59:59`).getTime()
    }

    if (params.side) {
      opts.side = params.side
    }

    if (isHide) {
      opts.status = [
        'Ack',
        'PartialFill',
        'IocNoFill',
        'FullyFill',
        'Expired',
        'Unknown',
        'FailedBlocking',
        'FailedMatching',
      ]
    }

    this.setState({ filterParams: opts }, () => {
      this._getOrderHistory(opts)
    })
  }

  _getDetailColumn = () => {
    const { formatI18nText } = this.props
    const columns = [
      {
        title: formatI18nText('orderHistory.tradeId'),
        headerAlign: 'left',
        sorter: true,
        dataIndex: 'tradeId',
        key: 'Trade ID',
        width: '20%',
        render: item => (
          <CellItem>
            <FontNumber value={item.tradeId} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.date'),
        dataIndex: 'date',
        headerAlign: 'left',
        sorter: true,
        key: 'Date',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={moment(item.date).format('YYYY-MM-DD h:mm:ss')} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('orderHistory.tradingPrice'),
        dataIndex: 'price',
        key: 'Trading Price',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={roundValue(item.price)} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.filled'),
        dataIndex: 'filled',
        key: 'Filled',
        width: '5%',
        render: item => (
          <CellItem>
            <FontNumber value={roundValue(item.filled)} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.total'),
        dataIndex: 'total',
        key: 'Total',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={item.total} />
          </CellItem>
        ),
      },
    ]
    return columns
  }

  _renderDetail = detail => {
    const detailData = detail.trade || []
    const { formatI18nText } = this.props
    const columns = this._getDetailColumn()
    const dataSource = detailData.map(d => ({
      tradeId: d.tradeId,
      date: d.time,
      price: d.price,
      filled: d.quantity,
      total: `${roundValue(d.price * d.quantity)} ${d.quoteAsset}`,
    }))
    const totalValue = dataSource.reduce(
      (n, pre) => parseFloat(n, 10) + parseFloat(pre.price, 10) * parseFloat(pre.filled, 10),
      0
    )
    const quotaAsset = (detailData[0] && detailData[0].quoteAsset) || ''
    return (
      <DetailContent>
        <DetailTotalValue>
          {`${formatI18nText('orderHistory.tradingTotal')}: ${roundValue(
            totalValue
          )} ${quotaAsset}`}
        </DetailTotalValue>
        <OrderTable columns={columns} dataSource={dataSource} />
      </DetailContent>
    )
  }

  _getExpandedRowAPiParams = record => {
    const { address } = this.props
    const params = { address }
    if (record.side.toUpperCase() === 'SELL') {
      params.sellerOrderId = record.id
    } else {
      params.buyerOrderId = record.id
    }
    return params
  }

  _fetchMore = async () => {
    const { offset, orders } = this.state
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) return

    const params = {
      address: user.address,
      offset: offset + 1,
      total: 1,
      limit: PAGE_SIZE,
    }

    const orderResponse = await httpRequest.getOrderHistoryQS(params)

    this.setState({ offset: offset + 1, orders: orders.concat(orderResponse.order) })
  }

  _buildMobileDataSource = () => {
    const { orders } = this.state
    const result = []
    orders.forEach(order => {
      result.push({
        txHash: order.transactionHash,
        id: order.orderId,
        date: order.transactionTime,
        pair: reduceTradePairBSufix(order.symbol),
        side: order.side === 1 ? 'Buy' : 'Sell',
        average: order.average,
        price: roundValue(order.price),
        amount: roundValue(order.quantity),
        cumulateQuantity: roundValue(order.cumulateQuantity),
        filled: (order.cumulateQuantity / order.quantity) * 100,
        total: roundValue(order.price * order.quantity),
        status: convertOrderStatus(order.status),
      })
    })

    return result
  }

  render() {
    const { isHide, isClickDetail } = this.state
    const { total, formatI18nText } = this.props
    const columns = this._buildColumns()
    const dataSource = this._buildDataSource()
    const mobileDataSource = this._buildMobileDataSource()

    return (
      <DexThemeProvider theme="light">
        <Layout>
          <Wrapper>
            <Content>
              <Title>{formatI18nText('header.orderHistory')}</Title>
              <FilterWrap>
                <div style={{ marginRight: '50px' }}>
                  <CheckBox
                    labelTitle={formatI18nText('exchange.hideAllCanceled')}
                    defaultChecked={isHide}
                    handleCheckChange={this._handleCheckChange}
                  />
                </div>
                <OrderHistoryFilter onFilterChange={this._filter} />
              </FilterWrap>
              <OrderTable
                columns={columns}
                dataSource={dataSource}
                paging={this._paging}
                total={total}
                primaryKey="id"
                expandedRowRender={this._renderDetail}
                expandedRowApi={`${GATE_WAY}${TRADE_API}`}
                expandedRowApiParam={this._getExpandedRowAPiParams}
              />
              {dataSource.length === 0 && (
                <NoContent text={formatI18nText('orderHistory.openHistory')} />
              )}
            </Content>
            <MobileContent className="mobileContent">
              <Title>{formatI18nText('header.orderHistory')}</Title>
              <InfiniteScroll
                dataLength={mobileDataSource.length}
                next={this._fetchMore}
                hasMore={total > mobileDataSource.length}
                loader={<h4>{formatI18nText('common.loading')}...</h4>}
              >
                {mobileDataSource.map(item => (
                  <OrderHistoryMobileItem order={item} />
                ))}
              </InfiniteScroll>
            </MobileContent>
          </Wrapper>
          {isClickDetail && <Loading />}
        </Layout>
      </DexThemeProvider>
    )
  }
}

const mapStateToProps = ({ account: { address }, order: { orderHistory } }) => ({
  orderHistory: orderHistory.order,
  total: orderHistory.total,
  address,
})

export default withI18n(connect(mapStateToProps)(OrderHistory))
